module.exports = __webpack_public_path__ + "static/computer-a360a515b8bac60a17ded28edb2578c0.jpg";